/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2023-06-14 15:56:54
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\wise\Wise_contactsbusiness\Wise_contactsbusiness.js
 */
import request from '@/utils/request'
/**1.获取未结算列表*/
export const queryPage1 = '/icps/system/sign/intelligent/proDispatchLogistics/getWaitSettleLogList'
/**2.获取已结算记录列表*/
export const queryPage2 = '/icps/system/sign/settlement/outsource/queryPage'
/**3.生成结算单*/
export function createFinalStatement(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/createFinalStatement',
    method: 'post',
    data
  })
}
/**4.保存结算单*/
export function saveFinalStatement(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/saveFinalStatement',
    method: 'post',
    data
  })
}
export function saveRawStatement(data) {
  console.log(data)
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/saveRawStatement',
    method: 'post',
    data
  })
}
/**5.获取结算单列表*/
export const queryPage3 = '/icps/system/sign/settlement/outsource/querySettledPage'
/**6.获取结算单明细*/
export function selectSettleDetail(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/selectSettleDetail',
    method: 'post',
    data
  })
}
/**.获取子结算单明细*/
export function selectRawSettleDetail(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/selectRawSettleDetail',
    method: 'post',
    data
  })
}
/**6.外协结算获取外协单位列表*/
export function getSupplierListForsettlement() {
  return request({
    url: '/icps/system/sign/settlement/outsource/getSupplierListForsettlement ',
    method: 'post'
  })
}
/**7.根据合同类型获取生效期内的合同列表*/
export function contract_list(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contract/contract_list',
    method: 'get',
    params: data
  })
}
/**7.根据合同类型获取生效期内的合同列表*/
export function queryUserByID(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contract/queryUserByID',
    method: 'post',
    data
  })
}
/**8.发送给供应商*/
export function informClient(data) {
  return request({
    url: '/icps/system/sign/settlement/client/informClient',
    method: 'post',
    data
  })
}
/**9.发送给供应商后改变状态*/
export function updateSettledPage(data) {
  return request({
    url: '/icps/system/sign/settlement/outsource/updateSettledPage',
    method: 'post',
    data
  })
}
/**9.发送给供应商*/
export function updateFinalStatementStatus(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/updateFinalStatementStatus',
    method: 'post',
    data
  })
}

/**10.打印结算单*/
export const outsourceexportList = '/icps/system/sign/settlement/outsource/exportList'
//生成子结算单
export function createRawSettle(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/createRawSettle',
    method: 'post',
    data
  })
}
/**11.导出结算单*/
export const exportSettlement = '/icps/system/sign/intelligent/proDispatchLogistics/exportSettlement'
export const exportRawSettlement = '/icps/system/sign/intelligent/proDispatchLogistics/exportRawSettlement'
/*12.删除结算单 */
export function deleteFinalStatement(data) {
  return request({
    url: '/icps/system/sign/intelligent/proDispatchLogistics/deleteFinalStatement',
    method: 'post',
    data
  })
}
/*13.获取补差数据 */
export function getCompensationList(data) {
  return request({
    url: '/icps/system/sign/settlement/outsource/getCompensationList',
    method: 'post',
    data
  })
}
/*14.获取该结算单已勾选补差数据 */
export function getCompensationListHistory(data) {
  return request({
    url: '/icps/system/sign/settlement/outsource/getCompensationListHistory',
    method: 'post',
    data
  })
}
